import getSdks from "../utils/sdks";

export const getLoyaltySDK = async () => {
  const loyaltySdk = await getSdks().loyalty;
  await loyaltySdk.initialize();

  return loyaltySdk;
};
